import { render, staticRenderFns } from "./ThreeDimensionalDialog.vue?vue&type=template&id=7dfa4248&scoped=true"
import script from "./ThreeDimensionalDialog.vue?vue&type=script&lang=js"
export * from "./ThreeDimensionalDialog.vue?vue&type=script&lang=js"
import style0 from "./ThreeDimensionalDialog.vue?vue&type=style&index=0&id=7dfa4248&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dfa4248",
  null
  
)

export default component.exports